// @flow

import type {MarkdocRenderTag} from 'markdoc/types';
import {isMarkdocAstTag} from 'docs/util';

export const findAllMarkdocTags = (
  tags: Array<MarkdocRenderTag | string>,
  predicate: (tag: MarkdocRenderTag) => boolean,
): Array<MarkdocRenderTag> => {
  const matches = [];

  // This should be able to be implemented as a simple call to tags.filter(),
  // but I can't get Flow to understand the types. >:|
  for (const tag of tags) {
    if (isMarkdocAstTag(tag) && typeof tag !== 'string' && predicate(tag)) {
      matches.push(tag);
    }
  }

  return matches;
};
